/** Must stay aligned with firestore.rules `matchRecordCreateValid` (schemaVersion == 1). */
export const MATCH_RECORD_SCHEMA_VERSION = 1;

export const MATCH_RECORD_STATUS = /** @type {const} */ ({
  COMPLETED: "completed",
  CANCELLED: "cancelled",
});

export const MATCH_TYPES = /** @type {const} */ (["singles", "doubles", "mixed"]);

export const MATCH_SIDES = /** @type {const} */ (["A", "B"]);

export const PARTICIPANT_RESULTS = /** @type {const} */ (["Win", "Loss"]);

/**
 * Client UUID for offline-first canonical match records (distinct from session `matches/{roomCode}`).
 * @returns {string}
 */
export function generateMatchRecordId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `mrec_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

export function generateParticipantId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `mp_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * @param {string} sessionRoomId
 * @param {number} completedAtMs
 * @param {string} winnerSide
 */
export function buildIdempotencyKey(sessionRoomId, completedAtMs, winnerSide) {
  return `${sessionRoomId}:${completedAtMs}:${winnerSide}`;
}
